import React from "react"
import Cabecalho from "../Cabecalho"
import { ComponentePrincipal } from "./components/ComponentePrincipal"

export function ComparativoUnidades() {
    return (
        <>
            <Cabecalho pagina="Comparativo de Lojas" />
            <ComponentePrincipal />
        </>
    )
}
